import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import TopNav from './topNav';
import './index.css';
import Nav from './nav';
import NewsStream from './newsStream';
import Footer from './footer';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const topNavData = {
            topnav: content.topnav,
            channel: content.channel,
        };
        const newsStreamData = {
            columnId: content.columnId,
            newsstream: content.newsstream,
            page: content.page,
            endPage: content.endPage,
            channel: content.channel,
        };

        return (
            <Fragment>
                <ChipEdit transform={transform} />
                <TopNav content={topNavData} />
                <Chip id="45012" type="struct" title="导航" groupName="导航" content={content.nav}>
                    <Nav columnId={content.columnId} />
                </Chip>
                <NewsStream content={newsStreamData} />
                <Footer content={content.footer} />
            </Fragment>
        );
    }
}

export default Layout;
